module.exports = __webpack_public_path__ + "src/client/assets/partner-logos/benchrs.png";